import type { Care, Light, PlantGroup, Style } from "./model";
import { assetUrl } from "../lib/asset";

export const FIXED_REFERENCE_DATE = "2026-08-03";
export const FIXED_SEED = "REUNANG-260730";

export const lightLabels: Record<Light, string> = {
  shade: "Râm sáng",
  morning: "Nắng sáng",
  partial: "Nắng bán phần",
  harsh: "Nắng gắt",
};

export const careLabels: Record<Care, string> = {
  light: "15 phút/tuần",
  medium: "30–45 phút/tuần",
  enthusiast: "Trên 60 phút/tuần",
};

export const careOrder: Record<Care, number> = {
  light: 1,
  medium: 2,
  enthusiast: 3,
};

export const styles: Style[] = [
  {
    id: "tropical-soft",
    name: "Nắng dịu nhiệt đới",
    shortName: "Nhiệt đới dịu",
    description:
      "Tán lá mềm, cao–thấp rõ và một ghế đọc nhỏ. Hợp ban công nắng sáng hoặc bán phần, công chăm vừa.",
    image: assetUrl("/media/style-nhiet-doi.webp"),
    palette: ["#244B3A", "#7D9A68", "#E9DFC9", "#B66A48"],
    materialTags: ["vôi mờ", "gỗ sáng", "gốm thô"],
    plantTags: ["tán", "rủ", "nền"],
    budgetHint: "12–24 triệu",
    ideal: "Nắng sáng · chăm vừa",
  },
  {
    id: "edible-wood",
    name: "Mộc ăn được",
    shortName: "Mộc ăn được",
    description:
      "Rau thơm và cây quả lùn đi cùng đất nung, kệ gọn và khoảng bàn pha trà. Cần nguồn nước gần và người thích chăm.",
    image: assetUrl("/media/style-moc-an.webp"),
    palette: ["#315B3C", "#B85F3D", "#D7A45D", "#F2E8D2"],
    materialTags: ["đất nung", "gỗ dầu", "kim loại mờ"],
    plantTags: ["thơm", "ăn được", "hoa"],
    budgetHint: "10–20 triệu",
    ideal: "Nắng sáng · thích chăm",
  },
  {
    id: "quiet-shade",
    name: "Tĩnh râm",
    shortName: "Tĩnh râm",
    description:
      "Xanh sâu, ít màu hoa, tập trung texture lá và một góc ngồi thấp. Hợp logia râm sáng, ít gió.",
    image: assetUrl("/media/style-tinh-ram.webp"),
    palette: ["#17372C", "#667461", "#A49B8B", "#D8C8AD"],
    materialTags: ["gốm than", "mây đan", "vữa khoáng"],
    plantTags: ["râm", "nền", "texture"],
    budgetHint: "11–22 triệu",
    ideal: "Râm sáng · chăm nhẹ",
  },
];

export const plantGroups: PlantGroup[] = [
  { id: "canopy", name: "Tạo tán", description: "Tạo chiều cao, riêng tư và nền xanh chính." },
  { id: "soft", name: "Lá mềm", description: "Lấp tầng giữa, làm dịu cạnh cứng của ban công." },
  { id: "trailing", name: "Rủ & viền", description: "Phủ mép chậu, tạo chuyển động ở tầng thấp." },
  { id: "edible", name: "Thơm & ăn được", description: "Mùi hương, lá gia vị hoặc quả nhỏ theo mùa." },
];
